__turbopack_context__.v({
  "btnRow": "HeroSection-module__pzGXVa__btnRow",
  "centerContainer": "HeroSection-module__pzGXVa__centerContainer",
  "circleGlow": "HeroSection-module__pzGXVa__circleGlow",
  "circleMask": "HeroSection-module__pzGXVa__circleMask",
  "circleWrapper": "HeroSection-module__pzGXVa__circleWrapper",
  "contentWrapper": "HeroSection-module__pzGXVa__contentWrapper",
  "cornerBox": "HeroSection-module__pzGXVa__cornerBox",
  "dottedRing": "HeroSection-module__pzGXVa__dottedRing",
  "heroSection": "HeroSection-module__pzGXVa__heroSection",
  "leftConnectorImg": "HeroSection-module__pzGXVa__leftConnectorImg",
  "leftFeature": "HeroSection-module__pzGXVa__leftFeature",
  "leftTagImg": "HeroSection-module__pzGXVa__leftTagImg",
  "leftTextBlock": "HeroSection-module__pzGXVa__leftTextBlock",
  "orangeBtn": "HeroSection-module__pzGXVa__orangeBtn",
  "rightConnectorImg": "HeroSection-module__pzGXVa__rightConnectorImg",
  "rightFeature": "HeroSection-module__pzGXVa__rightFeature",
  "rightTagImg": "HeroSection-module__pzGXVa__rightTagImg",
  "rightTextBlock": "HeroSection-module__pzGXVa__rightTextBlock",
  "rotateDots": "HeroSection-module__pzGXVa__rotateDots",
  "subText": "HeroSection-module__pzGXVa__subText",
  "title": "HeroSection-module__pzGXVa__title",
  "videoInside": "HeroSection-module__pzGXVa__videoInside",
  "whiteBtn": "HeroSection-module__pzGXVa__whiteBtn",
});
